import { render } from "./CalendarView.vue?vue&type=template&id=624979a0&scoped=true"
import script from "./CalendarView.vue?vue&type=script&lang=js"
export * from "./CalendarView.vue?vue&type=script&lang=js"

import "./CalendarView.vue?vue&type=style&index=0&id=624979a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624979a0"]])

export default __exports__